import styled from "styled-components";

import { P } from "core/Typography";
import { medium as mediumFont, regular as regularFont } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";
import MessageBanner from "components/MessageBanner";

export const CustomBanner = styled(MessageBanner)`
    padding: 0;
`;

export const MainText = styled(P)`
    ${mediumFont}
`;
export const SubText = styled(P)`
    ${regularFont}
    margin-top: ${convertPxToRem({ px: 2 })}
`;
